import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.EditWatchersPopup', {
    popupTitle: 'Change Watchers',
    readOnlyPopupTitle: 'Watchers',
    doneButtonTitle: 'Change Watchers',
    doneButtonText: 'Done',
    addApproverButtonText: 'Add Watcher',
    description:
        'Add or remove users from the watching list. Watchers can view documents, leave comments and receive notifications if something has changed.',
    watchersCanOnly: 'Watchers can view documents, leave comments and receive notifications if something has changed.',
    emptyWatchersAndReadonly: 'There is no watchers for this document.',
    successText: 'The Watchers have been changed.',
});
